/* Collapsible panel state persistence. */
/* Copied and modified from: static_src/js/c2Archive/collapsible.js */
(function (c2) {
  'use strict';

  /**
   * Persist state of collapsible panels in localStorage.
   *
   * All [data-toggle=collapse] elements within `container`, a selector or
   * jQuery object, will have their state immediately restored and persisted on
   * change.
   */
  function init(container) {
    var cacheKey = key();
    var $container = $(container);

    // Build a list of IDs for collapsible elements (strip leading # from data-bs-target)
    var collapsibleIDs = $container.find('[data-bs-toggle="collapse"]').map(function() {
      return $(this).data('bs-target').replace('#', '');
    }).get();

    // Restore collapsed state before hooking up shown/hidden event handler
    restoreCollapsedStateOfItems(cacheKey, $container);

    $container.on('shown.bs.collapse hidden.bs.collapse', function () {
      cacheCollapsedStateOfItems(cacheKey, collapsibleIDs);
    });
  }

  // Generate a unique cache key for this page
  function key() {
    return 'c2.collapsible' + window.location.pathname;
  }

  function getOpenCollapsibles(itemIDs) {
    return _.filter(itemIDs, function(item) {

      return $(`#${item}`).hasClass('show');
    });
  }

  function cacheCollapsedStateOfItems(cacheKey, itemIDs) {
    var openItems = getOpenCollapsibles(itemIDs);
    localStorage.setItem(cacheKey, JSON.stringify(openItems));
  }

  function restoreCollapsedStateOfItems(cacheKey, $container) {
    const openItems = localStorage.getItem(cacheKey);
    if (openItems === undefined || openItems === null) {
      return;
    }
    const panelIDs = JSON.parse(openItems);
    // If initial load, default panels closed
    if (panelIDs.length == 0 ) {
      return;
    }

    let $accordionContent;
    if (panelIDs && panelIDs.length) {
      _.forEach(panelIDs, function(panelID) {
        $accordionContent = $(`#${panelID}`);

        if ($accordionContent.length) {
          $accordionContent.addClass("show");
          // Trigger the show event so any global handlers can do their thing
          $accordionContent.trigger("show.bs.collapse");

          // Update the collapse trigger so the indicator is correct
          $('[data-bs-target="#' + panelID + '"]').removeClass("collapsed").attr("aria-expanded", "true");
        } else {
          // Silently ignore panels with persisted state that do not currently
          // exist in the DOM. This can happen when a panel was on a different page
          // of a DataTable, for example.
        }
      });
    }
  }


  // Expose public functions
  c2.collapsible = {
    init: init
  };

})(window.c2);
